// มาตรฐานรหัสผ่านเดียวกับ checkPasswordPolicy() ฝั่ง backend (HRvec_api/auth_helpers.php)
// แก้ที่นี่ที่เดียว ใช้ร่วมกันทุกฟอร์มที่ให้ผู้ใช้ตั้ง/เปลี่ยนรหัสผ่านเอง
export const PASSWORD_MIN_LENGTH = 8;

export function passwordRules() {
  return [
    v => !!v || "กรุณากรอกรหัสผ่าน",
    v =>
      (v && v.length >= PASSWORD_MIN_LENGTH) ||
      `รหัสผ่านต้องมีความยาวอย่างน้อย ${PASSWORD_MIN_LENGTH} ตัวอักษร`,
    v =>
      (v && /[A-Za-z]/.test(v)) ||
      "รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัว",
    v => (v && /[0-9]/.test(v)) || "รหัสผ่านต้องมีตัวเลขอย่างน้อย 1 ตัว"
  ];
}

// ใช้กับฟิลด์ "ยืนยันรหัสผ่าน" — ส่ง getter เพราะค่ารหัสผ่านอาจเปลี่ยนหลัง rule ถูกสร้าง
export function confirmPasswordRules(getPassword) {
  return [
    v => !!v || "กรุณายืนยันรหัสผ่าน",
    v => v === getPassword() || "รหัสผ่านไม่ตรงกัน"
  ];
}

// ใช้กับฟอร์มแก้ไขที่ "เว้นว่างไว้ = ไม่เปลี่ยนรหัสผ่าน" — เว้นว่างได้ แต่ถ้ากรอกต้องผ่านมาตรฐานเดียวกัน
export function optionalPasswordRules() {
  return [
    v =>
      !v ||
      v.length >= PASSWORD_MIN_LENGTH ||
      `รหัสผ่านต้องมีความยาวอย่างน้อย ${PASSWORD_MIN_LENGTH} ตัวอักษร`,
    v =>
      !v ||
      /[A-Za-z]/.test(v) ||
      "รหัสผ่านต้องมีตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัว",
    v => !v || /[0-9]/.test(v) || "รหัสผ่านต้องมีตัวเลขอย่างน้อย 1 ตัว"
  ];
}

export function optionalConfirmPasswordRules(getPassword) {
  return [
    v => !getPassword() || v === getPassword() || "รหัสผ่านไม่ตรงกัน"
  ];
}
